<div class="page">
  <app-section-toolbar
    [sectionTitle]="'MISSION.PARTICIPANTS' | translate"
    [hasStatus]="false"
    [addLabel]="'PARTICIPANT.NEW' | translate"
    (back)="backToMissionConfig()"
    (add)="openParticipantModal()">
  </app-section-toolbar>

  <section class="card">
    @let participants = participantsService.participants$ | async;
    @if (participants?.length) {
      <table class="data-table">
        <thead>
          <tr>
            <th>{{ 'PARTICIPANT.FIRST_NAME' | translate }}</th>
            <th>{{ 'PARTICIPANT.LAST_NAME' | translate }}</th>
            <th>{{ 'PARTICIPANT.EMAIL' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (participant of participants; track participant) {
            <tr>
              <td class="cell-strong">{{ participant.firstName }}</td>
              <td>{{ participant.lastName }}</td>
              <td class="cell-muted">{{ participant.email }}</td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <div class="empty-state">
        <ng-icon name="heroIdentification" size="32"/>
        <div class="empty-state__title">{{ 'UI.EMPTY.ATTENDEES' | translate }}</div>
        <div class="empty-state__text">{{ 'UI.EMPTY.ATTENDEES_TEXT' | translate }}</div>
      </div>
    }
  </section>
</div>

@if (displayModal) {
  <app-create-participant
    [missionId]="mission.missionId"
    (closeModal)="closeParticipantModal($event)"
  (reloadList)="reloadList()"></app-create-participant>
}
